
export default {
  name: 'query',
  head() {
    return {
      title: this.title + ' - Hirey',
      meta: [
        { hid: 'description', name: 'description', content: this.description + ' - Hirey'},
      ]
    }
  },
  data() {
    return {
      title: '',
      description: ''
    }
  },
  fetch() {
    const queryString = this.$route.params.query
    const arr = queryString.split('-')
    const qs = arr[0]
    const cityId = arr[1]
    const name = arr[2]
    const date = new Date()
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    function getMonthName(monthNumber) {
      const date = new Date();
      date.setMonth(monthNumber - 1);

      return date.toLocaleString('en-US', { month: 'long' });
    }
    const str = `${getMonthName(month)} ${day}, ${year}`

    if(cityId === '') {
      this.title = `${qs} Jobs - ${str} ｜ Hirey`
      this.description = `View the latest ${qs} Jobs and Vacancies. Chat directly with the hiring manager, get hired in hours!`
    } else if(qs === '') {
      this.title = `${name} Jobs - ${str} ｜ Hirey`
      this.description = `View the latest Jobs in ${name} and Vacancies. Chat directly with the hiring manager, get hired in hours!`
    } else {
      this.title = `${qs} Jobs in ${name} - ${str} ｜ Hirey`
      this.description = `View the latest ${qs} Jobs in ${name} and Vacancies. Chat directly with the hiring manager, get hired in hours!`
    }
  }
};
